module.exports = __webpack_public_path__ + "static/img/M-5.c6f8049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mzhongfu/M-5.png
// module id = v0ar
// module chunks = 0